// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-list {
  display: grid;
  grid-template-columns: 7rem auto;
  padding: 0 1rem 1rem 0;
  row-gap: 1rem;

  .card {
    border-top: var(--border-width) solid transparent;
    border-bottom: var(--border-elevated);
    display: grid;
    grid-column: span 2;
    grid-template-columns: subgrid;
    margin-top: 1rem;
    position: relative;
    row-gap: 0.7rem;

    &.confirming {
      & .data-item .data-value,
      & .aqumen-id .data-label,
      & .aqumen-id .display-id {
        color: var(--color-elevated-warn) !important;
        transition: none;
      }
    }
    .card-data,
    .card-data .data-item {
      display: grid;
      grid-column: span 2;
      grid-template-columns: subgrid;
      column-gap: 1rem;
      row-gap: 0.7rem;
    }

    .card-data .data-item {
      .data-label {
        color: var(--color-base-text);
        display: unset;
        grid-column: 1;
        text-align: right;
      }

      .data-value {
        grid-column: 2;

        input, select {
          width: calc(100% - 1rem);
          width: 100%;
        }
        input[type="datetime-local"] {
          width: calc(100% - 1.3rem);
        }
        input[type="number"] {
          width: calc(100% - 1.1rem);
        }
        textarea {
          width: calc(100% - 1rem);
        }
      }
    }
  }

  .card-title {
    grid-column: span 2;
    margin: 0;
    padding-left: 7.5rem;
  }

  .card-metadata {
    position: absolute; top: 0; right: 0;
  }

  .card-actions {
    grid-column: span 2;
    padding: 1rem 0;
    text-align: right;

    .create-button,
    .archive-button {
      width: 7rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/entity_list.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;;EAEb;IACE,iDAAiD;IACjD,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;;IAEf;MACE;;;QAGE,4CAA4C;QAC5C,gBAAgB;MAClB;IACF;IACA;;MAEE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE;QACE,6BAA6B;QAC7B,cAAc;QACd,cAAc;QACd,iBAAiB;MACnB;;MAEA;QACE,cAAc;;QAEd;UACE,wBAAwB;UACxB,WAAW;QACb;QACA;UACE,0BAA0B;QAC5B;QACA;UACE,0BAA0B;QAC5B;QACA;UACE,wBAAwB;QAC1B;MACF;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB,EAAE,MAAM,EAAE,QAAQ;EACtC;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;;IAEjB;;MAEE,WAAW;IACb;EACF;AACF","sourcesContent":[".entity-list {\r\n  display: grid;\r\n  grid-template-columns: 7rem auto;\r\n  padding: 0 1rem 1rem 0;\r\n  row-gap: 1rem;\r\n\r\n  .card {\r\n    border-top: var(--border-width) solid transparent;\r\n    border-bottom: var(--border-elevated);\r\n    display: grid;\r\n    grid-column: span 2;\r\n    grid-template-columns: subgrid;\r\n    margin-top: 1rem;\r\n    position: relative;\r\n    row-gap: 0.7rem;\r\n\r\n    &.confirming {\r\n      & .data-item .data-value,\r\n      & .aqumen-id .data-label,\r\n      & .aqumen-id .display-id {\r\n        color: var(--color-elevated-warn) !important;\r\n        transition: none;\r\n      }\r\n    }\r\n    .card-data,\r\n    .card-data .data-item {\r\n      display: grid;\r\n      grid-column: span 2;\r\n      grid-template-columns: subgrid;\r\n      column-gap: 1rem;\r\n      row-gap: 0.7rem;\r\n    }\r\n\r\n    .card-data .data-item {\r\n      .data-label {\r\n        color: var(--color-base-text);\r\n        display: unset;\r\n        grid-column: 1;\r\n        text-align: right;\r\n      }\r\n\r\n      .data-value {\r\n        grid-column: 2;\r\n\r\n        input, select {\r\n          width: calc(100% - 1rem);\r\n          width: 100%;\r\n        }\r\n        input[type=\"datetime-local\"] {\r\n          width: calc(100% - 1.3rem);\r\n        }\r\n        input[type=\"number\"] {\r\n          width: calc(100% - 1.1rem);\r\n        }\r\n        textarea {\r\n          width: calc(100% - 1rem);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .card-title {\r\n    grid-column: span 2;\r\n    margin: 0;\r\n    padding-left: 7.5rem;\r\n  }\r\n\r\n  .card-metadata {\r\n    position: absolute; top: 0; right: 0;\r\n  }\r\n\r\n  .card-actions {\r\n    grid-column: span 2;\r\n    padding: 1rem 0;\r\n    text-align: right;\r\n\r\n    .create-button,\r\n    .archive-button {\r\n      width: 7rem;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
